export const MapRankCss = {
  keywordTrackingTextSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '32px',
    color: '#120242'
  },
  analyzeFieldsBox: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '20px',
    marginTop: '24px'
  },
  analyzeFieldsLabel: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#5D5F6C',
    width: 'max-content'
  },
  analyzeFieldsLabelBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  popoverBoxSx: {
    minWidth: '158px',
    minHeight: '44px',
    borderRadius: '8px',
    border: '1px solid #D0D5DD',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: 2,
    cursor: 'pointer',
    backgroundColor: '#FFFFFF'
  },
  popoverSelectSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  popoverIcon: {
    color: '#120242'
  },
  popoverPaperProp: {
    minWidth: '158px'
  },
  popoverListItemBtn: {
    py: 0.5, // reduce top and bottom padding
    px: 2, // consistent left/right padding
    minHeight: '32px'
  },
  primaryTypographyProps: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    color: 'var(--color-primary)'
  },
  autoCompleteSx: {
    '& .MuiInputBase-root': {
      borderRadius: '6px',
      maxHeight: '44px',
      paddingTop: '3px'
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '6px',
      padding: '4px 8px',
      fontSize: 'var(--font-size-14)',
    },
    '& input::placeholder': {
      opacity: 1,
      fontSize: 'var(--font-size-14)',
    }
  },
  autoCompleteListItem: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingY: 1,
    paddingX: 2,
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%'
  },
  autoCompleteName: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    width: '100%',
    color: 'var(--color-text-heading)'
  },
  autoCompleteAddress: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    marginTop: '2px',
    textAlign: 'left',
    color: 'var(--color-text-heading)',
    width: '100%'
  },
  autoCompletePaperSx: {
    borderRadius: '10px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    marginTop: 1
  },

  searchBtn: {
    minWidth: '169px',
    maxHeight: '44px',
    borderRadius: '6px',
    padding: '12px 18px 12px 18px'
  },
  searchBtnBox: {
    display: 'flex',
    gap: '20px',
    alignItems: 'center'
  },
  searchMainBox: {
    marginTop: '16px',
    display: 'flex',
    gap: '6px',
    flexDirection: 'column'
  },
  recommendedKeywordsSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-tertiary)'
  },
  recommendedKeywordsSpanSx: {
    fontWeight: '500',
    color: 'var(--color-primary)'
  },
  createLocalRankingMapSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    color: 'var(--color-primary)'
  },
  createLocalRankingMapDescSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-tertiary)',
    marginTop: '8px',
    maxWidth: '650px'
  },
  createLocalRankingTitleBoxSx: {
    padding: '24px'
  },
  enteredKeywordSx: {
    color: 'var(--color-text-purple)'
  },
  overviewTextSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  overviewDateTextSx: {
    fontWeight: 700
  },
  keywordCardMainSx: {
    display: { xs: 'grid', md: 'flex' },
    gap: '16px',
    width: '100%',
    marginTop: '24px'
  },
  keywordCardSubSx: {
    borderRadius: '6px',
    padding: '16px',
    border: '1px solid #D0D5DD',
    width: '100%'
  },
  overviewCardTitleSx: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#5D5F6C'
  },
  overviewCardValueSx: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 'var(--font-size-30)',
    lineHeight: 'var(--line-height-38)',
    color: 'var(--color-primary)',
    marginTop: '16px'
  },
  ratingBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    mb: '12px',
    width: '100%'
  },
  ratingTitle: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#293241',
    minWidth: '92px'
  },
  ratingProgressSx: {
    width: '100%',
    height: 8,
    borderRadius: 32
  },
  ratingPerSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#120242',
    minWidth: '32px'
  },
  closeIcon: {
    color: 'var(--color-black)',
    marginTop: '-10px'
  },
  resultModalBoxSx: {
    padding: '32px'
  },
  resultModalTitleSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    color: 'var(--color-primary)'
  },
  resultModalTitleBoxSx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  resultModalDescSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-tertiary)',
    marginTop: '8px'
  },
  resultModalBtnSx: {
    maxHeight: '48px',
    borderRadius: '6px',
    padding: '12px 18px 12px 18px',
    marginTop: '32px'
  },
  resultModalTableBox: {
    marginTop: '32px',
    borderRadius: '12px',
    boxShadow: '0px 1px 8px 0px var(--color-shadow-card)'
  },
  modalRowNum: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    padding: '16px 16px 16px 0px'
  },
  modalRowName: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-primary)',
    padding: '16px 0px 16px 0px'
  },
  modalRowComSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-near-black)',
    padding: '16px 16px 16px 0px'
  },
  rowCellBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  rowNum: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    padding: '16px 16px 16px 0px'
  },
  rowName: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  rowAddress: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-14)',
    color: 'var(--color-primary)',
    marginTop: '4px'
  },
  rowRating: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-near-black)'
  },
  rowReviews: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-14)',
    color: 'var(--color-black)',
    marginTop: '4px'
  },
  rowArp: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-near-black)'
  },
  tabChipRecommended: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-white)',
    ml: 1,
    background: 'var(--color-primary)',
    opacity: '0.8'
  },
  tabsSx: {
    display: 'flex'
  },
  mapOverLayBoxSx: {
    width: '64px',
    height: '64px',
    borderRadius: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--color-white)',
    fontWeight: 'bold',
    fontSize: 'var(--font-size-20)',
    cursor: 'pointer',
    transform: 'translate(-50%, -50%)',
    boxSizing: 'border-box'
  },
  tabSelectedLabelSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  tabNotSelectedLabelSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-placeholder)'
  },
  recommendedContainerBoxSx: {
    borderRadius: '6px',
    padding: '16px',
    border: '1px solid var(--color-bg-purple-tint)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '12px'
  },
  recommendedIconBoxSx: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    flex: 1
  },
  recommendedTitleSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-primary)'
  },
  recommendedDescSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)',
    marginTop: '4px'
  },
  recommendedArrowIconSx: {
    color: 'var(--color-primary)',
    cursor: 'pointer'
  },
  analyzeFooterBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  keywordToSearchSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    color: 'var(--color-primary)'
  },
  keywordToSearchBracketSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  keywordToSearchBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  startNewText: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#FFFFFF'
  },
  startBtnBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  cardExtraCss: {
    maxHeight: '124px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  keywordNewCardMainSx: {
    display: { xs: 'grid', md: 'flex' },
    gap: '16px',
    width: '100%',
    marginTop: '12px'
  },
  overviewNewCardValueSx: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '32px',
    color: '#120242',
    marginTop: '16px'
  },
  popoverNewSelectSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#120242'
  },
  progressBarTitle: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-30)',
    lineHeight: 'var(--line-height-38)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  mapRankingSubTitle: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-text-heading)',
    marginTop: '32px'
  },
  mapRankingSubDesc: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-mid)',
    maxWidth: '510px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '12px',
    marginBottom: '12px'
  },
  noDataFound: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-heading)',
    paddingTop: '10px',
    paddingBottom: '10px'
  },
  mainFooterBox: {
    width: { xs: '100%', lg: 'calc(100% - 250px)' }, // Adjust 250px to match your sidebar width
    height: '78px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: '1px solid var(--color-border-light2)',
    padding: '15px 24px',
    boxShadow: '0px -1px 8px 0px var(--color-shadow-xs)',
    position: 'fixed',
    bottom: 0,
    left: { xs: 0, lg: '250px' }, // Match sidebar width
    backgroundColor: 'white',
    zIndex: 1000
  },
  newWindowBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  popoverPaperPropHeight: {
    maxHeight: '250px'
  },
  showNoDataTextSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    marginTop: '6px'
  },
  showNoDataSpanTextSx: {
    color: 'var(--color-primary)',
    textDecoration: 'underline',
    textDecorationThickness: '1.2px',
    cursor: 'pointer',
    textUnderlineOffset: '4px'
  },
  iconBoxCss: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    justifyContent: 'flex-end'
  },
  checkStatusBtnSx: {
    maxHeight: '44px',
    minWidth: '125px',
    fontWeight: 500,
    borderRadius: '6px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  checkStatusBoxSx: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'center'
  },
  primaryFontFieldTypographyProps: {
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    color: 'var(--color-primary)'
  },
  popoverFontSelectSx: {
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  }
};
